<template>
  <div>
    <div class="mainWrapper">
      <MainSideBarVue />

      <div class="rightContentWrapper">
        <div class="topNav">
          <TopBarVue />
        </div>

        <div class="innerContainer">
          <div class="theHeaderWrapper">
            <div>
              <i class="bi bi-arrow-left backIcon" @click="$router.go(-1)"></i> General
              Contractors
            </div>

            <button
              class="button-6"
              role="button"
              @click="groupTalkStore.goToAddGeneralContractorView"
            >
              New +
            </button>
          </div>

          <div class="searchBarWrapper" v-if="!groupTalkStore.generalContractors.length === 0">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control theBar"
              placeholder="Search by name..."
            />
          </div>

          <div class="tableWrapper" v-if="groupTalkStore.generalContractors.length > 0">
            <table class="table table-hover my-custom-table">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Reports Sent</th>
                  <th scope="col"></th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(gc, index) in filteredGeneralContractors" :key="index">
                  <td style="width: 300px">{{ gc.name }}</td>

                  <td style="width: 300px">
                    {{ gc.email }}
                  </td>

                  <td style="width: 300px">

                    <span class="badge rounded-pill bg-dark">

                      <div v-if="gc.report_logs && gc.report_logs.length > 0" 
                      @click="groupTalkStore.openGeneralContractorReportLogsModal(gc)"
                      style="cursor: pointer"
                      >
                        {{ gc.report_logs.length }}
                      </div>

                      <div v-else>0</div>

                    </span>
                  </td>

                  <td style="width: 150px">
                    <div class="iconsRow">
                      <i
                        @click="groupTalkStore.openUpdateGeneralContractorModal(gc)"
                        class="bi bi-pencil theActionIcon"
                      ></i>

                      <i
                        @click="groupTalkStore.openDeleteGeneralContractorModal(gc)"
                        class="bi bi-trash theActionIcon"
                      ></i>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else class="noGenBox">
            No general contractor added as yet.
          </div>
        </div>
      </div>
    </div>

    <div v-if="groupTalkStore.showAddGeneralContractorModal" class="modal-overlay">
      <div class="modal-box" style="width: 550px">
        <div class="model-box-header">
          <div style="font-size: 17px">
            <b>New General Contractor</b>
          </div>

          <div>
            <i
              @click="groupTalkStore.closeAddGeneralContractorModal"
              class="bi bi-x-lg"
              style="font-size: 20px; cursor: pointer"
            ></i>
          </div>
        </div>

        <div class="modal-content">
          <form @submit.prevent="groupTalkStore.addNewGeneralContractorInDB">
            <div class="mb-3">
              <label class="form-label" style="float: left"><b>Name</b></label>
              <input
                v-model="groupTalkStore.newGeneralContractorFormData.name"
                type="text"
                class="form-control inputStyle"
                required
              />
            </div>

            <div class="mb-3">
              <label class="form-label" style="float: left"><b>Email</b></label>
              <input
                v-model="groupTalkStore.newGeneralContractorFormData.email"
                type="email"
                @input="
                  groupTalkStore.checkIfGeneralContractorEmailIsVaildAndDoNotExistsInDB
                "
                class="form-control inputStyle"
                required
              />
            </div>

            <div
              class="mb-3"
              v-if="groupTalkStore.newGeneralContractorFormData.show_error"
            >
              <div class="alert alert-danger" role="alert">
                <b>{{ groupTalkStore.newGeneralContractorFormData.error_message }}</b>
              </div>
            </div>

            <div>
              <button type="submit" class="btn btn-dark createBTN">
                <b>Add</b>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div v-if="groupTalkStore.showUpdateGeneralContractorModal" class="modal-overlay">
      <div class="modal-box" style="width: 550px">
        <div class="model-box-header">
          <div style="font-size: 17px">
            <b>Update General Contractor</b>
          </div>

          <div>
            <i
              @click="groupTalkStore.closeUpdateGeneralContractorModal"
              class="bi bi-x-lg"
              style="font-size: 20px; cursor: pointer"
            ></i>
          </div>
        </div>

        <div class="modal-content">
          <form @submit.prevent="groupTalkStore.updateGeneralContractorInDB">
            <div class="mb-3">
              <label class="form-label" style="float: left"><b>Name</b></label>
              <input
                v-model="groupTalkStore.updateGeneralContractorFormData.name"
                type="text"
                class="form-control inputStyle"
                required
              />
            </div>

            <div class="mb-3">
              <label class="form-label" style="float: left"><b>Email</b></label>
              <input
                v-model="groupTalkStore.updateGeneralContractorFormData.email"
                type="email"
                @input="
                  groupTalkStore.checkIfUpdatedGeneralContractorEmailIsVaildAndDoNotExistsInDB
                "
                class="form-control inputStyle"
                required
              />
            </div>

            <div
              class="mb-3"
              v-if="groupTalkStore.updateGeneralContractorFormData.show_error"
            >
              <div class="alert alert-danger" role="alert">
                <b>{{ groupTalkStore.updateGeneralContractorFormData.error_message }}</b>
              </div>
            </div>

            <div>
              <button type="submit" class="btn btn-dark createBTN">
                <b>Update</b>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div v-if="groupTalkStore.showDeleteGeneralContractorModal" class="modal-overlay">
      <div class="modal-box" style="width: 550px">
        <div class="model-box-header">
          <div style="font-size: 17px; text-align: left">
            <b>Are you sure you want to delete this General Contractor?</b>
          </div>

          <div>
            <i
              @click="groupTalkStore.closeDeleteGeneralContractorModal"
              class="bi bi-x-lg"
              style="font-size: 20px; cursor: pointer"
            ></i>
          </div>
        </div>

        <div class="modal-content" style="text-align: left">
          <p
            v-if="
              groupTalkStore.updateGeneralContractorFormData.name &&
              groupTalkStore.updateGeneralContractorFormData.email
            "
          >
            <b style="color: red">Very Important Note:</b> Deleting
            <b>{{ groupTalkStore.updateGeneralContractorFormData.name }}</b> will remove
            all email report logs that was sent by supervisors to
            <b>{{ groupTalkStore.updateGeneralContractorFormData.email }}</b
            >. This data cannot be recovered when deleted.
          </p>

          <div>
            <button
              @click="groupTalkStore.deleteThisGeneralContractor"
              type="button"
              class="btn btn-danger createBTN"
            >
              <b>Yes, Delete!</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="groupTalkStore.showGeneralContractorReportLogsModal" class="modal-overlay">
      <div class="modal-box" style="width: 700px">
        <div class="model-box-header">
          <div style="font-size: 17px" v-if="groupTalkStore.currentGeneralContractor">
            <b>{{groupTalkStore.currentGeneralContractor.name}}</b>
          </div>

          <div>
            <i
              @click="groupTalkStore.closeGeneralContractorReportLogsModal"
              class="bi bi-x-lg"
              style="font-size: 20px; cursor: pointer"
            ></i>
          </div>
        </div>

        <div class="modal-content">

        <!-- {{groupTalkStore.currentGeneralContractor}} -->

          <div class="innerBox" v-if="groupTalkStore.currentGeneralContractor && groupTalkStore.currentGeneralContractor.report_logs">

        
              <div
                class="talkItem"
                v-for="(gc_log, index) in groupTalkStore.currentGeneralContractor.report_logs"
                :key="index"
                
              >
                <div class="talkLeft">
                  <div class="talkTitle" style="font-size: 12px;">
                    <b>Topic: </b> 

                    <span v-if="gc_log.group_talk_post && gc_log.group_talk_post.post">
                      {{gc_log.group_talk_post.post.title}}
                    </span>

                  </div>

                  <div class="talkTitle" style="font-size: 12px;">
                    <b>Report Sent:</b> {{ gc_log.created_at }}
                  </div>
                </div>

                <div class="talkRight">

                  <a
                      v-if="gc_log.pdf_url"
                      :href="gc_log.pdf_url"
                      target="_blank"
                      class="btn btn-dark btn-sm"
                      style="margin-right: 10px; font-size: 12px;"
                  >
                      View PDF
                  </a>
                </div>
              </div>
       

          </div>

         
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import MainSideBarVue from "@/components/MainSideBar";
import TopBarVue from "@/components/TopBar.vue";
import { useGroupTalkStore } from "@/stores/GroupTalkStore";
import { onMounted, ref, computed } from "vue";

const groupTalkStore = useGroupTalkStore();

const searchQuery = ref("");

const filteredGeneralContractors = computed(() => {
  return (groupTalkStore.generalContractors || []).filter((gc) =>
    gc.name?.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
});

onMounted(() => {
  groupTalkStore.fetchAllGeneralContractors();
});
</script>

<style scoped>
.mainWrapper {
  /* background-color: aliceblue; */
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.rightContentWrapper {
  /* overflow-y: auto; */
  width: 83%;
  display: flex;
  flex-direction: column;
}

.contentContainer {
  /* overflow-y: auto; */
  background-color: rgb(208, 28, 55);
  /* margin: 30px; */
  margin-top: 100px;
}

.rightColumns {
  /* display: flex;
  flex-direction: column; */
}

.topNav {
  background-color: blue;
}

.innerContainer {
  /* margin-top: 200px; */
  /* background-color: blueviolet; */
  overflow-y: auto;
  padding-top: 30px;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 100px;
}

.theHeaderWrapper {
  display: flex;
  justify-content: space-between;
  text-align: left;
  font-size: 20px;
  font-weight: bold;
  /* background-color: aqua; */
}

.searchBarWrapper {
  margin-top: 15px;
  width: 100%;
  padding-bottom: 20px;
  /* background-color: rgb(22, 166, 37); */
}

.theBar {
  width: 350px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 10px;
}

.button-6 {
  align-items: center;
  /* background-color: #FFFFFF; */
  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  display: inline-flex;
  font-family: system-ui, -apple-system, system-ui, "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-size: 16px;
  font-weight: 600;
  justify-content: center;
  line-height: 1.25;
  margin: 0;
  min-height: 3rem;
  padding: calc(0.875rem - 1px) calc(1.5rem - 1px);
  position: relative;
  text-decoration: none;
  transition: all 250ms;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: baseline;
  width: auto;
}

.button-6:hover,
.button-6:focus {
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
  color: rgba(0, 0, 0, 0.65);
}

.button-6:hover {
  transform: translateY(-1px);
}

.button-6:active {
  background-color: #f0f0f1;
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
  color: rgba(0, 0, 0, 0.65);
  transform: translateY(0);
}

.tableWrapper {
  margin-top: 20px;
  /* background-color: aqua; */
  width: 100%;
}

.my-custom-table tbody tr td {
  padding-top: 20px;
  /* Adjust the value as needed */
  padding-bottom: 20px;
  /* Adjust the value as needed */
}

.my-custom-table th {
  padding-bottom: 20px;
}

.my-custom-table th,
.my-custom-table td {
  text-align: left;
  /* Aligns text to the left */
  padding-left: 20px;
  padding-right: 20px;
}

.campName {
  text-decoration: none;
  color: inherit;
}

.campName:hover {
  color: rgb(10, 159, 92);
  cursor: pointer;
  text-decoration: none;
}

.iconsRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.theActionIcon {
  font-weight: bolder;
  font-size: 18px;
  color: rgb(5, 2, 2);
  cursor: pointer;
}

.theActionIcon:hover {
  cursor: pointer;
  color: rgb(30, 158, 30);
  scale: 1.3;
  transition: 1s;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  /* Semi-transparent black background */
  display: flex;
  justify-content: center;
  /* Center horizontally */
  align-items: center;
  /* Center vertically */
  z-index: 999;
  /* Ensure the modal is on top */
}

/* Styles for the modal box */
.modal-box {
  background-color: white;
  width: 1100px;
  padding: 20px;
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-content {
  text-align: center;
}

.model-box-header {
  display: flex;
  justify-content: space-between;
  /* background-color: antiquewhite; */
  height: 40px;
  margin-bottom: 15px;
}

.form-control {
  background-color: rgb(243, 246, 246);
}

.createBTN {
  width: 100%;
  margin-top: 20px;
}

.noTeamBox {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  width: 100%;
}

.noMatchBox {
  background-color: red;
  width: 100%;
}

.loadMoreBtn {
  background-color: black;
  border-radius: 10px;
}

.inviteInput {
  width: 500px;
  font-size: 13px;
  cursor: pointer;
}

.backIcon {
  margin-right: 10px;
  font-size: 27px;
  cursor: pointer;
}

.innerBox {
    /* background-color: red; */
    overflow-y: auto;
    width: 100%;
    height: 500px;
    padding: 12px;
}


.talkItem {
    display: flex;
    flex-direction: row;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 10px;
    margin-bottom: 25px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.talkItem:hover {
    background-color: rgb(249, 253, 252);
}

.talkLeft {
    display: flex;
    flex-direction: column;
    padding: 5px;
    width: 80%;
    /* background-color: #aadada; */
}

.talkRight {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20%;
    /* padding: 10px; */
    /* background-color: #3ddbdb; */
}

.talkTitle {
    /* background-color: #d9e7ff; */
    text-align: left;
    /* font-weight: bold; */
    padding: 6px;
}

.noGenBox{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 200px;
  padding: 20px;
}

</style>
